import React from 'react';

const PlanningCrewFilter = ({
  allCrews,
  selectedCrews,
  handleCrewFilterChange,
  setSelectedCrews,
}) => {
  return (
    <div className="w-64 lg:w-80">
      <div className="rounded-lg border border-gray-200/50 bg-white/90 p-3 shadow-sm backdrop-blur-sm">
        <div className="mb-2 flex items-center justify-between">
          <h3 className="text-xs font-medium text-gray-700">Crews</h3>
          {selectedCrews.length > 0 && (
            <button
              onClick={() => setSelectedCrews([])}
              className="text-xs text-blue-600 hover:text-blue-700"
            >
              Clear
            </button>
          )}
        </div>
        <div className="max-h-32 space-y-1 overflow-y-auto">
          {allCrews.map((crew) => (
            <label
              key={crew.id}
              className="flex cursor-pointer items-center space-x-2 rounded bg-white/60 px-2 py-1.5 transition-colors hover:bg-white/80"
            >
              <input
                type="checkbox"
                checked={selectedCrews.includes(Number(crew.id))}
                onChange={() => handleCrewFilterChange(crew.id)}
                className="h-3 w-3 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <span className="truncate text-xs text-gray-700">{crew.name}</span>
            </label>
          ))}
        </div>
        {selectedCrews.length > 0 && (
          <div className="mt-2 text-xs text-gray-600">
            {selectedCrews.length} crew{selectedCrews.length !== 1 ? 's' : ''} selected
          </div>
        )}
      </div>
    </div>
  );
};

export default PlanningCrewFilter;
